module.exports = __webpack_public_path__ + "img/edit.802be1df.svg";